function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { ItemType, PostPageTodosAndTodoLists_ItemFragmentDoc, usePostPage_NewTodoListMutation } from "sprout-graphql";
import generateOptimisticId from "@sprout/client-lib/dist/generateOptimisticId";
import update from "immutability-helper";
import generateRandomKey from "@sprout/client-lib/dist/generateRandomKey";
import { useSnackbar } from "sprout-ui-dom/dist/Snackbar";
import { getIsLargePointerDevice } from "sprout-ui-dom/dist/utils";
import { usePostPageEditor } from "../PostPageEditorContext";
import PostPageTodoListEditor from "./PostPageTodoListEditor";
const PostPageTodoListNewEditor = (props)=>{
    const { postId , postNodeId  } = props;
    const [createTodoList] = usePostPage_NewTodoListMutation();
    const { state , dispatch  } = usePostPageEditor();
    const closeTodoListEditor = useCallback(()=>{
        dispatch({
            type: "CLOSE_EDITOR"
        });
    }, [
        dispatch
    ]);
    const showSnackbar = useSnackbar();
    const handleSubmit = useCallback((description)=>{
        createTodoList({
            variables: {
                postId,
                description
            },
            update (proxy, { data  }) {
                var ref;
                const options = {
                    fragment: PostPageTodosAndTodoLists_ItemFragmentDoc,
                    id: postNodeId,
                    fragmentName: "PostPageTodosAndTodoLists_Item"
                };
                const cache = proxy.readFragment(options);
                const item = data === null || data === void 0 ? void 0 : (ref = data.createItem) === null || ref === void 0 ? void 0 : ref.item;
                if (item) proxy.writeFragment(_objectSpread({}, options, {
                    data: update(cache, {
                        todoLists: {
                            nodes: {
                                $apply: (nodes)=>[
                                        item,
                                        ...nodes.filter(({ id: todoListId  })=>todoListId !== item.id), 
                                    ]
                            }
                        }
                    })
                }));
            },
            optimisticResponse: {
                createItem: {
                    item: {
                        id: generateOptimisticId(),
                        nodeId: generateRandomKey(),
                        type: ItemType.Checklist,
                        description,
                        commentCount: 0,
                        archivedAt: null,
                        createdAt: new Date().toISOString(),
                        isExplicitlyArchived: false,
                        deletedAt: null,
                        isExplicitlyDeleted: false,
                        // it does not matter what the position is
                        position: -1,
                        parentTopicId: postId,
                        rootTopicOrSelf: null,
                        todos: {
                            nodes: [],
                            __typename: "ItemsConnection"
                        },
                        __typename: "Item"
                    },
                    __typename: "CreateItemPayload"
                }
            }
        }).catch(()=>{
            showSnackbar.error();
        });
        closeTodoListEditor();
        /**
       * Note: `MAX_SAFE_INTEGER` is used to create orphan todos, and
       * `MIN_SAFE_INTEGER` is used to create `TodoList` todos.
       *
       * This opens `PostPageTodoListNewButton` upon creation, so that
       * is shows an editor.
       */ dispatch({
            type: "SET_EDITOR",
            payload: {
                variant: getIsLargePointerDevice() ? "desktop" : "mobile",
                editor: "CREATE_TODO",
                editorPosition: Number.MIN_SAFE_INTEGER
            }
        });
    }, [
        createTodoList,
        postId,
        closeTodoListEditor,
        dispatch,
        postNodeId,
        showSnackbar, 
    ]);
    if (state.editor !== "CREATE_TODOLIST") return null;
    return /*#__PURE__*/ _jsx(PostPageTodoListEditor, {
        onSubmit: handleSubmit,
        onCancel: closeTodoListEditor
    });
};
export default PostPageTodoListNewEditor;
